import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactHtmlParser from 'react-html-parser';
import DataTable from "react-data-table-component";

import { API_BASE_URL } from '../../config.js';
import { statisticsAction, statisticsCloseAction } from '../../actions/settingsAction.js';
import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';

const Inchargeot = ({ fixNavbar }) => {

  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const [isApproving, setIsApproving] = useState(false);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  /* ================= HORIZONTAL SCROLL ================= */
  const tableScrollRef = useRef(null);
  const scrollTable = (direction) => {
    if (tableScrollRef.current) {
      tableScrollRef.current.scrollBy({
        left: direction === "left" ? -250 : 250,
        behavior: "smooth",
      });
    }
  };

  /* ================= FETCH DATA ================= */
  const fetchData = () => {
    axios.get(`${API_BASE_URL}/incharge_overtime_list`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
    })
    .then(res => setData(res.data || []))
    .catch(() => toast.error("Failed to load overtime list"));
  };

  useEffect(() => {
    fetchData();
  }, []);

  /* ================= SEARCH ================= */
  const filteredData = data.filter(item =>
    `${item.employee_id}${item.employee_name}${item.department_name}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  /* ================= PAGINATION ================= */
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * entriesPerPage,
    currentPage * entriesPerPage
  );

  /* ================= SELECT ALL ================= */
  const selectableRows = filteredData.filter(row => row.floor_status === 1);
  const isAllSelected =
    selectableRows.length > 0 &&
    selectableRows.every(row => selectedIds.includes(row.overtime_id));

  const toggleSelectAll = () => {
    if (isAllSelected) {
      setSelectedIds([]);
    } else {
      setSelectedIds(selectableRows.map(row => row.overtime_id));
    }
  };

  /* ================= SINGLE CHECKBOX ================= */
  const handleCheckboxChange = (id) => {
    setSelectedIds(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  /* ================= BULK APPROVE ================= */
  const approveSelected = () => {
    if (isApproving) {
      return;
    }

    if (selectedIds.length === 0) {
      toast.info("No records selected!", { position: "bottom-right", theme: "colored" });
      return;
    }

    setIsApproving(true);

    axios.post(
      `${API_BASE_URL}/incharge_overtime_approve_bulk`,
      { overtime_ids: selectedIds, status: "Approved" },
      { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
    )
    .then(() => {
      toast.success("Selected records approved!", { position: "bottom-right" });
      setSelectedIds([]);
      fetchData();
    })
    .catch(() => toast.error("Approval failed"))
    .finally(() => setIsApproving(false));
  };

  /* ================= DATATABLE COLUMNS ================= */
  const columns = [
    {
      name: (
        <input
          type="checkbox"
          checked={isAllSelected}
          onChange={toggleSelectAll}
        />
      ),
      cell: row =>
        row.floor_status === 1 ? (
          <input
            type="checkbox"
            checked={selectedIds.includes(row.overtime_id)}
            onChange={() => handleCheckboxChange(row.overtime_id)}
          />
        ) : null,
      ignoreRowClick: true,
      width: "60px",
    },
   {
  name: "Action",
  selector: row =>
    Number(row.floor_status) === 1 ? 1 : 0,
  sortable: true,
  cell: row =>
    Number(row.floor_status) === 1 ? (
      <Link to={`/inchargeotdetails?id=${row.overtime_id}`}>
        <i className="fe fe-maximize" />
      </Link>
    ) : null,
  ignoreRowClick: true,
  width: "100px",
}
,
    { name: "Employee ID", selector: row => row.employee_id, sortable: true },
    { name: "Employee", selector: row => row.employee_name, sortable: true },
    { name: "Department", selector: row => row.department_name, sortable: true },
    { name: "Overtime Hours", selector: row => row.overtime_hour, sortable: true },
    { name: "Overtime Date", selector: row => row.overtime_date, sortable: true },
  {
  name: "Reason",
  cell: row => {
    const reason = row.reason || "";
    const shortText =
      reason.length > 5 ? reason.substring(0, 5) + "..." : reason;

    return (
      <div className="remark-hover-wrapper">
        {shortText}
        <div className="remark-hover-box">
          {reason}
        </div>
      </div>
    );
  },
  sortable: true,
  wrap: true,
}

,
    { name: "Incharge", cell: row => ReactHtmlParser(row.incharge_status) },
    { name: "HOD", cell: row => ReactHtmlParser(row.hod_status) },
    { name: "HR", cell: row => ReactHtmlParser(row.hr_status) },
  ];

  return (
    <>
      <ToastContainer />
      <div className={`section-body ${fixNavbar ? "marginTop" : ""}`}>
        <div className="container-fluid">
          <div className="card">

            {/* HEADER */}
            <div className="card-header d-flex justify-content-between align-items-center">
          <h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
              <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501zm-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z"/><path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z"/><path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5"/>
            </svg>
            Manage Overtime
          </h3>

              <div style={{ display: "flex", alignItems: "center" }}>
                <EntriesSelector
                  entriesPerPage={entriesPerPage}
                  setEntriesPerPage={setEntriesPerPage}
                  setCurrentPage={setCurrentPage}
                />

                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                  style={{ width: "250px", marginLeft: "15px" }}
                />
              </div>
            </div>

            {/* TABLE */}
            <div className="card-body" style={{ position: "relative" }}>
              {/* Left scroll arrow */}
              <button
                type="button"
                onClick={() => scrollTable("left")}
                title="Scroll left"
                style={{
                  position: "absolute",
                  left: "-2px",
                  top: "45%",
                  transform: "translateY(-50%)",
                  zIndex: 5,
                  border: "none",
                  background: "transparent",
                  color: "#e96827",
                  fontSize: "24px",
                  fontWeight: "bold",
                  lineHeight: 1,
                  cursor: "pointer",
                }}
              >
                &laquo;
              </button>

              {/* Right scroll arrow */}
              <button
                type="button"
                onClick={() => scrollTable("right")}
                title="Scroll right"
                style={{
                  position: "absolute",
                  right: "-2px",
                  top: "45%",
                  transform: "translateY(-50%)",
                  zIndex: 5,
                  border: "none",
                  background: "transparent",
                  color: "#e96827",
                  fontSize: "24px",
                  fontWeight: "bold",
                  lineHeight: 1,
                  cursor: "pointer",
                }}
              >
                &raquo;
              </button>

              <div
                className="table-responsive"
                ref={tableScrollRef}
                style={{ overflowX: "auto", width: "100%", padding: "0 22px" }}
              >
                <DataTable
                  columns={columns}
                  data={paginatedData}
                  highlightOnHover
                  striped
                  responsive={false}
                  persistTableHead
                  noDataComponent="No overtime records found"
                />
              </div>

              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
              />

              <button
                className="btn btn-primary mt-3"
                onClick={approveSelected}
                disabled={isApproving || selectedIds.length === 0}
              >
                {isApproving ? "Approving..." : "Approve OT"}
              </button>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  fixNavbar: state.settings.isFixNavbar
});

export default connect(mapStateToProps)(Inchargeot);
